import React, { FC } from 'react';
import translate from '@translate';
import { useNavigate } from 'react-router-dom';
import { AddIcon, ReloadIcon } from 'src/components/SkladonIcon/Icons';
import TransportsSectionTopBlock from '../TransportsSection/TopBlock';
import SyncIcon from '@mui/icons-material/Sync';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';

interface TopBlockProps {
    reloadList: () => void;
    syncGeis: () => void;
    syncCatalogue: () => void;
    permissionCreate: boolean;
    permissionSync: boolean;
}

const TopBlock: FC<TopBlockProps> = (props) => {
    const navigate = useNavigate();

    return (
        <TransportsSectionTopBlock
            actions={[
                {
                    onClick: props.reloadList,
                    icon: <ReloadIcon />,
                    tooltip: translate('transportPackageTypes.action.reload'),
                    variant: 'outlined',
                },
                {
                    onClick: props.syncCatalogue,
                    icon: <Inventory2OutlinedIcon />,
                    tooltip: translate('transportPackageTypes.action.syncCatalogue'),
                    variant: 'outlined',
                    hidden: !props.permissionSync,
                    'data-testid': 'package-types-sync-catalogue-btn',
                },
                {
                    onClick: props.syncGeis,
                    icon: <SyncIcon />,
                    tooltip: translate('transportPackageTypes.action.sync'),
                    variant: 'outlined',
                    hidden: !props.permissionSync,
                    'data-testid': 'package-types-sync-btn',
                },
                {
                    label: translate('transportPackageTypes.action.createNew'),
                    onClick: () => navigate('/transports/package-types/new'),
                    icon: <AddIcon />,
                    hidden: !props.permissionCreate,
                    'data-testid': 'package-types-create-btn',
                },
            ]}
        />
    );
};

export default TopBlock;
